import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import HealthTracker from "../../../views/Bienestar/HealthTracker";

const Bienestar = ({ setShowBienestar }) => {
    return (
        <Routes>
            <Route exact path="/bienestar"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <HealthTracker setShowBienestar={setShowBienestar} />
                       </Suspense>
                   }>
            </Route>
        </Routes>
    )
}

export default Bienestar